import { BE_LIMIT_TYPE } from '@/components/Limits/constants'
import { isArray } from '@/util/validators/baseComponentsValidators'
import { createState } from '~/util/storeHelpers'

const GAMES_PLAY_ERROR_STATUS = {
  insufficientBalance: 'insufficient_balance',
  insufficientRealBalance: 'insufficient_real_balance',
  verificationRequired: 'verification_required',
  gameSessionLimitExceeded: 'game_session_limits_exceeded',
  requiredLimitsNotSet: 'required_limits_not_setted',
}

const game = createState({ key: 'game', initialValue: {} })

export const state = () => ({
  game: game.state,
})

export const mutations = {
  set_game: game.setter,
}

export const actions = {
  async fetch_game({ commit, getters }, { isLoggedIn, term } ) {
    if (getters.get_game.isLoading) return
    commit('set_game', { isLoading: true })
    try {
      const { data } = await this.$api.games.getGame( { isLoggedIn, term } )
      const limitsArr = data?.errors?.exceeded_limits
      if (data.status === false && isArray(limitsArr)) {
        const limitObj =  limitsArr.find(limitObj => limitObj.type === BE_LIMIT_TYPE.GAME_SESSION)
        if (!limitObj) return
        commit('limits/set_gameExceededLimits', limitObj, { root: true })
      }

      commit('set_game', { data })
    }
    catch (error) {
      console.log('fetchGame Error ', error)
      commit('set_game', { error: error })
    }
    finally {
      commit('set_game', { isLoading: false })
    }
  },
}

export const getters = {
  get_game: game.getter,
  get_isShowLimitsExceededModal: (_, getters) => getters.get_game?.data?.errors?.user === GAMES_PLAY_ERROR_STATUS.gameSessionLimitExceeded,
}
